import React, { Component } from 'react';
import moment from 'moment';

import Header from '../components/Header';
import SideMenu from '../components/SideMenu';

import TemperatureFilter from '../components/Temperature/Filter';
import TemperatureChart from '../components/Temperature/Chart';
import TemperatureApi from '../psuite-js/apis/temperatures/temperature';

import Snackbar from 'material-ui/Snackbar';

const DEFAULT_INTERVAL = '10';

class TemperatureContainer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            is_fetched: false,
            temperatures: [],
            interval: DEFAULT_INTERVAL,
            error: false
        }
    }

    fetchData(filter = {}) {
        const start = (filter.start) ? moment(filter.start) : moment();
        const end = (filter.end) ? moment(filter.end) : moment();
        this.setState({interval: filter.interval || DEFAULT_INTERVAL});

        if (end < start) {
            alert('A data inicial não pode ser menor que a final.');
            return;
        }

        if (end.diff(start, 'days') > 1) {
            alert('Por favor, selecione um periodo de no máximo um dia.');
            return;
        }

        const params = {
            filter: {
                datetime: {
                    $gte: start.format('YYYY-MM-DD HH:mm Z'),
                    $lte: end.format('YYYY-MM-DD HH:mm Z'),
                },
                context: 'delivery',
                source_id: filter.vehicle_id || ''
            },

            order: [ ["datetime", "asc"] ]
        };

        this.setState({loading: true});

        TemperatureApi.all(params).then(result => {
            this.setState({temperatures: result.data.data, loading: false, is_fetched: true});
        }).catch(e => {
            console.error(e);
            this.setState({temperatures: [], loading: false});
            alert('Falha ao recuperar os dados!');
        });
    }

    getTemperatureReport() {
        if (!this.state.is_fetched) {
            return (
                <div style={{color: '#999'}}>
                    <div className="text-center">
                    <i className="fa fa-thermometer-full" style={{fontSize: '3.2em', marginBottom: '20px'}}></i>
                    </div>

                    <p className="text-center">
                        Informe o período, intervalo e o veículo para consultarmos os dados de temperatura.
                    </p>
                </div>
            );
        }

        return (<TemperatureChart interval={this.state.interval} temperatures={this.state.temperatures}  />);
    }

    render() {
        return (
            <div>
                <Header />
                <div className="container-fw">
                    <SideMenu />

                    <div className="flex-container temperatures-review">
                        <TemperatureFilter defaultInterval={DEFAULT_INTERVAL} onSubmit={this.fetchData.bind(this)} />

                        <div className="temperature-chart">
                            {this.getTemperatureReport()}
                        </div>

                        <Snackbar
                            anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                            open={this.state.loading}
                            message={<span>Carregando...</span>}
                        />
                    </div>
                </div>
            </div>
        );
    }

}

export default TemperatureContainer;



// WEBPACK FOOTER //
// ./src/containers/temperature.js